import { CompletedActivity } from "./student-completed-activities";

export class DaisyChainConversation
{
    Name: string;
    Description: string;
    ConversationArtifactID: string;
    IsCompletedByStudent: boolean;
    CreatedArtifacts: CreatedArtifactMetadata[];
}

export class CreatedArtifactMetadata
{
    ArtifactID: string;
    DateGenerated: Date;
    StartedActivityID: string;
    ArtifactType: string;
    Context: string;
    CourseCode: string;
    ActivityID: string;
    UnitNumber: number;
}

export class DaisyChainConversationArtifact
{
    ConversationID: string;
    OtherPartyID: string;
    OtherPartyType: CreatorType;
    Responses: VideoOrAudioOnlyResponse[];
    CreationTimeUtc: Date;
}

export class BundledResponses
{
    BotResponses: VideoOrAudioOnlyResponse[];
    StudentResponse: VideoOrAudioOnlyResponse;
}

export class VideoOrAudioOnlyResponse
{
    CreatorID: string;
    CreatorType: CreatorType;
    BotResponseName: string;
    VideoID: string;
    CreationTimeUtc: Date;
    VideoFormat: VideoFormat;
    ThumbnailArtifactID: string;
    Transcript: string;
    VideoHeight: number;
    VideoWidth: number;
}

export enum CreatorType
{
    Bot,
    Student,
    Account //Teacher, Parent, etc
}

export enum VideoFormat
{
    unknown,
    m3u8,
    mp4,
    webm,
    audioOnly
}

export class DaisyChainVideoPrompts
{
    LutUrl: string;
    ParseDate: string;
    VideoPrompts: DaisyChainVideoPrompt[];
}

export class DaisyChainVideoPrompt
{
    VideoFilename: string;
    Prompt: string;
}